import VisibilityIcon from 'assets/icons/visibility.svg?react';
import VisibilityOffIcon from 'assets/icons/visibility-off.svg?react';
import { useCallback, useState } from 'react';
import TextInput, { type ITextInputProps } from 'components/inputs/TextInput';

const PasswordInput = ({ type, ...props }: ITextInputProps) => {
  const [showPassword, changePasswordVisibility] = useState(false);

  const handleToggle = useCallback(() => {
    changePasswordVisibility(!showPassword);
  }, [showPassword]);

  return (
    <TextInput
      {...props}
      type={showPassword ? 'text' : 'password'}
      endIcon={
        showPassword ? (
          <VisibilityOffIcon style={{ cursor: 'pointer' }} onClick={handleToggle} />
        ) : (
          <VisibilityIcon style={{ cursor: 'pointer' }} onClick={handleToggle} />
        )
      }
    />
  );
};

export default PasswordInput;
